{
  "es": {
    "titleNew": "Nuevo Inventario",
    "titleEdit": "Editar Inventario",
    "titleDetails": "Detalle de Inventario",
    "badgeTemplate": "Plantilla autocargada",
    "bannerTitle": "Estancias e ítems precargados automáticamente",
    "bannerBody": "según el piso. El comercial revisa: marca, cantidad, si hay en el piso, quién lo pone si falta, calidad, observaciones y foto. Los ítems con * son obligatorios. Podés guardar el avance en cualquier momento (queda pendiente) y continuar después. Para algo extra, usa “Agregar ítem”.",
    "progressLabel": "Revisado",
    "progressOf": "de",
    "expandAll": "Expandir todo",
    "collapseAll": "Contraer",
    "itemsFromCatalog": "ítems",
    "addSection": "Agregar estancia",
    "sectionTitlePlaceholder": "Nombre de la estancia",
    "removeSection": "Quitar estancia",
    "generalNotes": "Notas generales del informe",
    "generalNotesPlaceholder": "Ej.: El salón se encuentra en perfecto estado…",
    "saveInventory": "Guardar inventario",
    "inspectorRequired": "El nombre del inspector es obligatorio.",
    "abandonTitle": "Vas a abandonar el inventario",
    "abandonBody": "Perderás el progreso. ¿Estás seguro?",
    "abandonConfirm": "Abandonar",
    "abandonSavePending": "Dejarlo pendiente a terminar",
    "abandonKeepEditing": "Seguir editando",
    "pendingBadge": "Pendiente",
    "savingTitle": "Guardando inventario…",
    "savingBody": "Esto puede tardar unos segundos si hay muchos ítems. No cierres esta ventana.",
    "savingProgress": "Progreso",
    "incompleteRequired": "Hay ítems obligatorios sin revisar:",
    "incompletePhotos": "Falta al menos 1 foto en: {rooms}.",
    "saveBlockedHint": "Aún faltan ítems (*) o fotos. Podés guardar igual: quedará pendiente hasta completarlos.",
    "seeMoreIncomplete": "Ver más ({count})",
    "editLockedByDate": "Este inventario ya no se puede editar: pasaron más de 2 días desde la inspección. Solo consulta.",
    "generatePdf": "Generar PDF",
    "labels": {
      "id": "ID de Inventario",
      "description": "Descripción",
      "items": "Ítems",
      "quantity": "Cantidad",
      "itemDescription": "Ítem",
      "itemNotes": "Observaciones",
      "inspector": "Inspector / Entrega *"
    },
    "buttons": {
      "addItem": "Agregar ítem",
      "addItemHint": "Elige del catálogo o escribe uno nuevo",
      "back": "Volver",
      "accept": "Aceptar",
      "downloadPdf": "Descargar PDF",
      "removeItem": "Quitar"
    }
  },
  "en": {
    "titleNew": "New Inventory",
    "titleEdit": "Edit Inventory",
    "titleDetails": "Inventory Details",
    "badgeTemplate": "Template auto-loaded",
    "bannerTitle": "Rooms and items preloaded automatically",
    "bannerBody": "based on the property. Review: check, quantity, whether it is in the property, who provides it if missing, condition, notes and photo. Items with * are required. You can save progress anytime (it stays pending) and continue later. To add something extra, use “Add item”.",
    "progressLabel": "Reviewed",
    "progressOf": "of",
    "expandAll": "Expand all",
    "collapseAll": "Collapse",
    "itemsFromCatalog": "items",
    "addSection": "Add room",
    "sectionTitlePlaceholder": "Room name",
    "removeSection": "Remove room",
    "generalNotes": "General report notes",
    "generalNotesPlaceholder": "E.g.: The living room is in perfect condition…",
    "saveInventory": "Save inventory",
    "inspectorRequired": "Inspector name is required.",
    "abandonTitle": "You are about to leave this inventory",
    "abandonBody": "You will lose your progress. Are you sure?",
    "abandonConfirm": "Abandon",
    "abandonSavePending": "Leave pending to finish later",
    "abandonKeepEditing": "Keep editing",
    "pendingBadge": "Pending",
    "savingTitle": "Saving inventory…",
    "savingBody": "This may take a few seconds if there are many items. Do not close this window.",
    "savingProgress": "Progress",
    "incompleteRequired": "Required items are still incomplete:",
    "incompletePhotos": "At least 1 photo is missing in: {rooms}.",
    "saveBlockedHint": "Some required items (*) or photos are still missing. You can save anyway — it will stay pending until completed.",
    "seeMoreIncomplete": "See more ({count})",
    "editLockedByDate": "This inventory can no longer be edited: more than 2 days have passed since the inspection. View only.",
    "generatePdf": "Generate PDF",
    "labels": {
      "id": "Inventory ID",
      "description": "Description",
      "items": "Items",
      "quantity": "Quantity",
      "itemDescription": "Item",
      "itemNotes": "Notes",
      "inspector": "Inspector / Handover *"
    },
    "buttons": {
      "addItem": "Add item",
      "addItemHint": "Pick from catalog or type a new one",
      "back": "Back",
      "accept": "Accept",
      "downloadPdf": "Download PDF",
      "removeItem": "Remove"
    }
  }
}
